import styled from "@emotion/styled";

export const ChangePasswordCardContainer = styled.div`
    
    #reset-password-form-actions-container {
        display: flex;
        justify-content: flex-end;
    }
`;